import { render, staticRenderFns } from "./MergeDetail.vue?vue&type=template&id=b4f95972"
import script from "./MergeDetail.vue?vue&type=script&lang=js"
export * from "./MergeDetail.vue?vue&type=script&lang=js"
import style0 from "./MergeDetail.vue?vue&type=style&index=0&id=b4f95972&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports